import { css } from 'styled-components';
import { AuthorInfoContainer } from '../../../../components/AuthorInfo/styles';
import { StyledImg } from '../../../../components/LazyImg/styles';
import spacing from '../../../../helpers/spacing';
import { themeSpecificColors } from '../../colors';

export default css`
  ${AuthorInfoContainer} {
    border: 1px solid ${themeSpecificColors.core02_20};

    /* RSA brand sets border radius globally to 0, so here we need to override back to the standard value */
    ${StyledImg} {
      border-radius: ${spacing(3)};
    }

    a[href^='mailto:'] {
      word-break: break-all;
    }
  }
`;
